import {merge} from 'external/lodash' 
import moment from 'external/moment'
import {styled, Drawer} from "external/material"
import DashboardCourses from './DashboardCourses'
import DashboardSidebarCalendar from './DashboardCalendar'
import DashboardSidebarTopbar from './DashboardTopbar'

import { mixStyle } from 'utils/style'

import useSession from 'hooks/session'
import useStudent from 'hooks/student'

const StyledSidebar = styled(Drawer)(sidebarStyles)

export default function DashboardSidebar(props) {
    const {navigation} = useSession()
    const {date} = useStudent()

    const displayingToday = moment(date()).isSame(moment(), 'month')
    const canCloseSidebar = props.open && !props.isDesktop

    function onCalendarChange (e) {
      const {activeStartDate: date, view} = e
      navigation.page.goWithQuery({
        start: date
          ? moment(date).startOf(view).startOf('day').format('YYYY-MM-DD')
          : undefined,
        end: date
          ? moment(date).endOf(view).endOf('day').format('YYYY-MM-DD')
          : undefined
      }, true)
    }

    return (
        <StyledSidebar open={props.open} variant="persistent" anchor="right">
            <DashboardSidebarTopbar {...{canCloseSidebar, setMenuOpen: props.setOpen, onCalendarChange, navigation, displayingToday}} />
            <DashboardSidebarCalendar {...{onCalendarChange, navigation}} />
            <DashboardCourses />
        </StyledSidebar>
    )
}

function sidebarStyles({theme}) {

    const paperSizing = mixStyle(theme.mixins.toolbar, ['minHeight', 'maxHeight'], (height, type) => {
      if (type == 'maxHeight') return
      const toolbarHeight = height * 2
      return {
        height: `calc(100% - ${toolbarHeight}px)`,
        marginTop: `${toolbarHeight}px`,
      }
    })

    return {
      "& .MuiPaper-root": {
        ...merge(paperSizing, theme.mixins.sidebar),
        backgroundColor: '#fff',
        boxShadow: "-2px 0px 2px 1px #e7e8ea",
      }
    }
}
